import { cn } from "@/lib/utils";
import { Reveal } from "@/components/motion-primitives";

// Primary / secondary / outline pill CTA. Renders <a> when href given, else <button>.
export const CTAButton = ({
  children, variant = "primary", href, onClick, className = "",
  icon: Icon, testId, type, size = "md",
}) => {
  const base =
    "group inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-all duration-300 will-change-transform hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-secondary";
  const sizes = { md: "px-7 py-3.5 text-sm", sm: "px-5 py-2.5 text-sm", lg: "px-8 py-4 text-base" };
  const variants = {
    primary: "bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_10px_30px_-8px_rgba(15,23,42,0.5)]",
    secondary: "bg-secondary text-secondary-foreground hover:brightness-95 shadow-[0_10px_30px_-8px_rgba(247,148,29,0.55)]",
    outline: "border border-white/25 text-white hover:bg-white/10 backdrop-blur-sm",
    outlineDark: "border border-primary/20 text-primary hover:border-primary/50 hover:bg-primary/5",
    ghost: "text-primary hover:text-secondary",
  };
  const cls = cn(base, sizes[size], variants[variant], className);
  const inner = (
    <>
      {children}
      {Icon && <Icon className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />}
    </>
  );
  if (href) {
    return (
      <a href={href} onClick={onClick} data-testid={testId} className={cls}>{inner}</a>
    );
  }
  return (
    <button type={type || "button"} onClick={onClick} data-testid={testId} className={cls}>{inner}</button>
  );
};

export const Overline = ({ children, className = "", dark = false }) => (
  <span className={cn("overline inline-flex items-center gap-2", dark ? "text-secondary" : "text-secondary", className)}>
    <span className="w-6 h-px bg-secondary/70" />
    {children}
  </span>
);

export const SectionHeader = ({ overline, title, subtitle, dark = false, center = false, className = "" }) => (
  <div className={cn(center ? "text-center mx-auto max-w-2xl" : "max-w-3xl", className)}>
    {overline && <Reveal><Overline dark={dark}>{overline}</Overline></Reveal>}
    <Reveal delay={0.05}>
      <h2 className={cn("mt-5 text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-[1.08]", dark ? "text-white" : "text-primary")}>
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p className={cn("mt-5 text-base md:text-lg leading-relaxed", dark ? "text-white/70" : "text-muted-foreground")}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
